import { Injectable } from '@angular/core';
import { catchAndGetFromFailureRxOp } from '@geekbears/gb-ngrx-stack-base';
import { Actions, createEffect, EffectsModule, ofType } from '@ngrx/effects';
import { map, mergeMap } from 'rxjs';
import { RequestsTypeServices } from '../../domain/services/requests-type.service';
import { RequestsTypeActions } from './requests-type.actions';

@Injectable()
export class RequestsTypeEffects {
  constructor(
    private actions$: Actions,
    private requestsTypeService: RequestsTypeServices
  ) {}

  allRequestsType$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RequestsTypeActions.getAllRequestsType),
      mergeMap((action) => {
        return this.requestsTypeService.getAllRequestsType().pipe(
          map((requestsType) =>
            RequestsTypeActions.getAllRequestsTypeSuccess({ requestsType })
          ),
          catchAndGetFromFailureRxOp((failure) =>
            RequestsTypeActions.getAllRequestsTypeFailure({ failure })
          )
        );
      })
    );
  });

  updateRequestsType$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RequestsTypeActions.updateRequestType),
      mergeMap((action) => {
        return this.requestsTypeService
          .updateRequestType(action.id, action.action)
          .pipe(
            map((response) =>
              RequestsTypeActions.updateRequestTypeSuccess({ response })
            ),
            catchAndGetFromFailureRxOp((failure) =>
              RequestsTypeActions.updateRequestTypeFailure({ failure })
            )
          );
      })
    );
  });

  deleteRequestsType$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RequestsTypeActions.deleteRequestType),
      mergeMap((action) => {
        return this.requestsTypeService
          .deleteRequestType(action.requestsTypeId)
          .pipe(
            map((response) =>
              RequestsTypeActions.deleteRequestTypeSuccess({ response })
            ),
            catchAndGetFromFailureRxOp((failure) =>
              RequestsTypeActions.deleteRequestTypeFailure({ failure })
            )
          );
      })
    );
  });

  createRequestsType$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RequestsTypeActions.createRequestType),
      mergeMap((action) => {
        return this.requestsTypeService
          .createRequestType(action.requestType)
          .pipe(
            map((response) =>
              RequestsTypeActions.createRequestTypeSuccess({ response })
            ),
            catchAndGetFromFailureRxOp((failure) =>
              RequestsTypeActions.createRequestTypeFailure({ failure })
            )
          );
      })
    );
  });

  requestActionsByCompany$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RequestsTypeActions.getRequestActionsByCompany),
      mergeMap((action) => {
        return this.requestsTypeService
          .getRequestActionsByCompany(action.companyId)
          .pipe(
            map((response) =>
              RequestsTypeActions.getRequestActionsByCompanySuccess({
                response,
              })
            ),
            catchAndGetFromFailureRxOp((failure) =>
              RequestsTypeActions.getRequestActionsByCompanyFailure({ failure })
            )
          );
      })
    );
  });
  changeRequestActionType$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RequestsTypeActions.changeRequestActionType),
      mergeMap((action) => {
        return this.requestsTypeService
          .changeRequestActionType(action.companyId, action.data)
          .pipe(
            map((response) =>
              RequestsTypeActions.changeRequestActionTypeSuccess({
                response,
              })
            ),
            catchAndGetFromFailureRxOp((failure) =>
              RequestsTypeActions.changeRequestActionTypeFailure({ failure })
            )
          );
      })
    );
  });
}
export const RequestsTypeEffectsModule = EffectsModule.forFeature([
  RequestsTypeEffects,
]);
